import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Checkbox, Modal, Radio, Select, Typography } from 'antd';
import { useEffect, useState } from 'react';
import colors from '../../../../constants/ColourConstants';
import TextArea from 'antd/es/input/TextArea';

export default function UpdatePyoutModal({
  onOk,
  open,
  setOpen,
  n,
  count,
  selectedRows,
}) {
  const { Text } = Typography;
  const [invoiceUpdateType, setInvoiceUpdateType] = useState('selected');
  const [newStatus, setNewStatus] = useState({
    status: null,
    update_status: true,
    update_notes: false,
    notes: '',
  });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [eligibleKeys, seteligibleKeys] = useState([]);

  useEffect(() => {
    if (open) {
      let keys = [];
      selectedRows.map((ele) => {
        if (!ele.isLocked) {
          keys.push(ele.payoutId);
        }
      });
      seteligibleKeys(keys);
    }
  }, [open]);

  const handleUpdateStatus = () => {
    if (newStatus.update_status) {
      setNewStatus({ ...newStatus, update_status: false, update_notes: true });
    } else {
      setNewStatus({ ...newStatus, update_status: true });
    }
  };

  const handleNotesStatus = () => {
    if (newStatus.update_notes) {
      setNewStatus({
        ...newStatus,
        update_status: true,
        update_notes: false,
      });
    } else {
      setNewStatus({
        ...newStatus,
        update_notes: true,
      });
    }
  };

  const handleOnOk = (invoiceUpdateType, newStatus) => {
    let payload = {};
    if (newStatus.update_status) {
      payload['updatedStatus'] = newStatus.status;
    }
    if (newStatus.update_notes) {
      payload['updatedNotes'] = newStatus.notes;
    }
    onOk(invoiceUpdateType, null, payload);
    setNewStatus({
      status: null,
      update_status: true,
      update_notes: false,
      notes: '',
    });
    setShowConfirmModal(false);
  };

  return (
    <>
      <Modal
        title="Update Statuses & Notes"
        open={open}
        onCancel={() => setOpen(false)}
        footer={[
          <Button key="back" onClick={() => setOpen(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={
              (invoiceUpdateType === 'selected' && eligibleKeys?.length <= 0) ||
              (newStatus.update_status && newStatus.status === null) ||
              (newStatus.update_notes && newStatus.notes === '')
            }
            onClick={() => {
              setShowConfirmModal(true);
              setOpen(false);
            }}
          >
            Update
          </Button>,
        ]}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Text>Choose which payout to update.</Text>
          <Text style={{ fontSize: 12 }} italic>
            Note: Voided payouts can not be updated.
          </Text>
        </div>
        <Radio.Group
          onChange={(e) => setInvoiceUpdateType(e.target.value)}
          defaultValue={'selected'}
          value={invoiceUpdateType}
          style={{
            display: 'flex',
            flexDirection: 'column',
            margin: '8px 0',
            gap: 4,
          }}
        >
          <Radio value={'selected'}>
            Selected payouts only -{' '}
            <Text strong>{eligibleKeys.length || 0} payouts selected</Text>
          </Radio>
          <Radio value={'query'}>
            All eligible payouts - <Text strong>{count || 0} payouts </Text>
          </Radio>
        </Radio.Group>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            margin: '12px 0',
          }}
        >
          <Text>What do you want to update?</Text>
          <Text strong>
            <Checkbox
              style={{ marginRight: '10px' }}
              checked={newStatus.update_status}
              onChange={() => handleUpdateStatus()}
            />
            Update payout status
          </Text>
          <div style={{ marginLeft: '22px', display: 'grid', gap: '8px' }}>
            <Text>Status</Text>
            <Select
              onSelect={(v) => {
                setNewStatus({ ...newStatus, status: v });
              }}
              value={newStatus.status}
              placeholder="Select status"
              style={{ width: '60%' }}
            >
              <Radio value={'Under Further Review'}>Under Further Review</Radio>
              <Radio value={'Ready to Remit'}>Ready to Remit</Radio>
              <Radio value={'Payout Initiated'}>Payout Initiated</Radio>
              <Radio value={'Voided'}>Voided</Radio>
            </Select>
          </div>

          <Text strong>
            <Checkbox
              style={{ marginRight: '10px' }}
              checked={newStatus.update_notes}
              onClick={() => handleNotesStatus()}
            />
            Add or modify notes
          </Text>
          <div
            style={{
              margin: '22px 0px 20px 0px',
              display: 'grid',
              gap: '8px',
            }}
          >
            <Text>Notes</Text>
            <TextArea
              showCount
              maxLength={64}
              value={newStatus.notes}
              onChange={(e) => {
                setNewStatus({ ...newStatus, notes: e.target.value });
              }}
              placeholder="Enter notes"
            />
          </div>
        </div>
      </Modal>

      <Modal
        width={'45%'}
        open={showConfirmModal}
        title={
          <>
            <ExclamationCircleOutlined style={{ color: colors.colorWarning }} />
            <Text style={{ marginLeft: 8 }}>Confirm Status Update</Text>
          </>
        }
        onCancel={() => {
          setShowConfirmModal(false);
          setOpen(true);
        }}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setShowConfirmModal(false);
              setOpen(true);
            }}
          >
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => {
              handleOnOk(invoiceUpdateType, newStatus);
            }}
          >
            Confirm
          </Button>,
        ]}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            marginLeft: '25px',
          }}
        >
          <Text>
            You&apos;re about to update{' '}
            <Text strong>
              {invoiceUpdateType == 'selected' ? eligibleKeys?.length : count}{' '}
              payouts
            </Text>{' '}
            {newStatus.update_status && `based on your selected status.`}
          </Text>
          {newStatus.update_status && (
            <Text>
              <ul
                style={{
                  paddingLeft: 20,
                  marginBottom: 0,
                  listStyleType: 'disc',
                }}
              >
                <li style={{ marginBottom: 8 }}>
                  Change status to <Text strong>{newStatus.status}</Text>
                </li>
              </ul>
            </Text>
          )}
          {newStatus.update_notes && (
            <Text>
              <ul
                style={{
                  paddingLeft: 20,
                  marginBottom: 0,
                  listStyleType: 'disc',
                }}
              >
                <li style={{ marginBottom: 8 }}>
                  Add note:<Text strong>{`"${newStatus.notes}"`}</Text>
                </li>
              </ul>
            </Text>
          )}
          <Text>Do you want to proceed?</Text>
        </div>
      </Modal>
    </>
  );
}
